import React, { useState, useEffect } from 'react';

import application from 'application';
import internalEventCodes from 'event-system/codes/internal';

import DeviecAccessStatusDisplay from './dialogs/device-access-status-display';
import MeetingAttendeeList from './dialogs/meeting-attendees-list';

import './index.scss';
import EventJoiningInstructions from './dialogs/event-joining-instructions';

function AsyncDialogManager(props) {

  const [rootState, setRootState] = useState({
    displayDeviceAccessNeededInformationDialog: null,
    displayAttendeesList: null,
    displayEventJoiningInstructions: null
  });

  useEffect(function onLoad() {

    const listeners = [
      listenToDeviceAccessNeededEvent,
      listenToDisplayMeetingAttendeesEvent,
      registerHideMeetingAttendeesEvent,
      listenToDisplayJoiningInstructionsEvent
    ];
    const unlisteners = [];

    for (let listener of listeners) {
      unlisteners.push(listener());
    }

    return function unlistenEvents() {

      for (let unlistener of unlisteners) {

        unlistener();

      }

    };

  }, []);

  function listenToDeviceAccessNeededEvent() {

    function handleDeviceAccessNeededEvent(data) {

      setRootState(function updateRootState(rootState) {

        return {
          ...rootState,
          displayDeviceAccessNeededInformationDialog: data
        };

      });

    }

    application.eventSystem.internal.on(internalEventCodes.DISPLAY_MICROPHONE_AND_CAMERA_ACCESS_NEEDED_MESSAGE, handleDeviceAccessNeededEvent);

    return function unlistenUserProfileUpdatedEvent() {

      application.eventSystem.internal.off(internalEventCodes.DISPLAY_MICROPHONE_AND_CAMERA_ACCESS_NEEDED_MESSAGE, handleDeviceAccessNeededEvent);

    };

  }

  function listenToDisplayMeetingAttendeesEvent() {

    function handleDisplayMeetingAttendeesEvent(data) {

      setRootState(function updateRootState(rootState) {

        return {
          ...rootState,
          displayAttendeesList: data
        };

      });

    }

    application.eventSystem.internal.on(internalEventCodes.DISPLAY_MEETING_ATTENDEES_LIST, handleDisplayMeetingAttendeesEvent);

    return function unlistenUserProfileUpdatedEvent() {

      application.eventSystem.internal.off(internalEventCodes.DISPLAY_MEETING_ATTENDEES_LIST, handleDisplayMeetingAttendeesEvent);

    };

  }

  function registerHideMeetingAttendeesEvent() {

    function handleHideMeetingAttendeesEvent() {

      setRootState(function updateRootState(rootState) {

        return {
          ...rootState,
          displayAttendeesList: null
        };

      });

    }

    application.eventSystem.internal.on(internalEventCodes.HIDE_MEETING_ATTENDEES_LIST, handleHideMeetingAttendeesEvent);

    return function unregisterHideMeetingAttendeesEvent() {
      application.eventSystem.internal.off(internalEventCodes.HIDE_MEETING_ATTENDEES_LIST, handleHideMeetingAttendeesEvent);
    };

  }

  function listenToDisplayJoiningInstructionsEvent() {

    function handleDisplayEventJoiningInstructions(data) {

      setRootState(function updateRootState(rootState) {

        return {
          ...rootState,
          displayEventJoiningInstructions: data
        };

      });

    }

    application.eventSystem.internal.on(internalEventCodes.DISPLAY_EVENT_JOINING_INSTRUCTIONS, handleDisplayEventJoiningInstructions);

    return function unlistenTooDisplayJoiningInstructionsEvent() {
      application.eventSystem.internal.off(internalEventCodes.DISPLAY_EVENT_JOINING_INSTRUCTIONS, handleDisplayEventJoiningInstructions);
    };

  }

  function renderDeviceAccessNeededDialog() {

    const deviecAccessStatusDisplayProperties = {
      ...rootState.displayDeviceAccessNeededInformationDialog,
      onClose() {
        setRootState({
          ...rootState,
          displayDeviceAccessNeededInformationDialog: null
        });
      }
    };

    return <DeviecAccessStatusDisplay {...deviecAccessStatusDisplayProperties} />;

  }

  function renderMeetingAttendeesListDialog() {

    const meetingAttendeesListProperties = {
      ...rootState.displayAttendeesList,
      onClose() {
        setRootState({
          ...rootState,
          displayAttendeesList: null
        });
      }
    };

    return <MeetingAttendeeList {...meetingAttendeesListProperties} />;

  }

  function renderEventJoiningInstructionsDialog() {

    const eventJoiningInstructionsProperties = {
      ...rootState.displayEventJoiningInstructions,
      onClose() {
        setRootState({
          ...rootState,
          displayEventJoiningInstructions: null
        });
      }
    };

    return <EventJoiningInstructions {...eventJoiningInstructionsProperties} />;
  }

  function renderDialogs() {

    if (rootState.displayDeviceAccessNeededInformationDialog !== null) {
      return renderDeviceAccessNeededDialog();
    } else if (rootState.displayAttendeesList !== null) {
      return renderMeetingAttendeesListDialog();
    } else if (rootState.displayEventJoiningInstructions !== null) {
      return renderEventJoiningInstructionsDialog();
    }

    return '';

  }

  function renderMain() {

    return <div id="async-dialog-manager-main">
      {renderDialogs()}
    </div>;

  }

  return renderMain();

}

export default AsyncDialogManager;